import { Box, Typography } from "@mui/material";
import CustomDocumentIndicatiors from "../indicators/CustomDocumentIndicatiors";
import DownloadIcon from "@mui/icons-material/Download";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";
import React from "react";

const CustomDocumentMiddleContent = ({
  setFileSizeModalOpen,
  isMobile = false,
  display = "flex",
}) => {
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);

  const { ppDownloading } = useSelector(
    (state) => state.myPermitsComponent.permits.loadings,
  );

  const actions = selectedRow?.document?.actions || {};
  const permit = selectedRow?.processing_permit || {};

  const notarizeInProgress = actions?.notarize && !selectedRow?.notarized;
  const recordInProgress = actions?.record && !permit?.recording?.recorded;

  const notarizeDone = actions?.notarize && selectedRow?.notarized;
  const recordDone = actions?.record && permit?.recording?.is_recorded;

  const showInProgressMessage = notarizeInProgress || recordInProgress;
  const showCompletedMessage = notarizeDone || recordDone;

  return (
    <>
      <Box
        className="step15"
        sx={{
          display,
          flexDirection: "column",
          borderLeft:
            isMobile || selectedRow?.package_type === "noc"
              ? undefined
              : "4px solid #d3d3d3",
          mx: isMobile ? 0 : 1,
          flex: 1,
        }}
      >
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="h5"
            align="center"
            color="primary"
            px={2}
            mb={0}
            sx={{ fontSize: "22px" }}
          >
            {selectedRow?.package_type === "noc"
              ? "Notice of Commencement"
              : ""}
          </Typography>
        </Box>

        {/* Status Indicators */}
        <CustomDocumentIndicatiors selectedRow={selectedRow} />
        {/* END OF STATUS INDICATORS */}

        {/* In Progress Message */}
        {showInProgressMessage && (
          <Box
            sx={{
              mx: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <Typography
              px={2}
              pt={2}
              mt={2}
              mb={1}
              align="center"
              variant="h5"
              sx={{
                color: "#4caf50",
                fontSize: "22px",
              }}
            >
              {notarizeInProgress
                ? "Notarization has been initiated and is currently in progress..."
                : recordInProgress
                  ? "Recording has been initiated and is currently in progress..."
                  : ""}
            </Typography>

            <Typography
              px={2}
              align="center"
              fontWeight="bold"
              variant="body2"
              color="primary"
            >
              You can review and manage all parts of the notarization and
              recording process using the panel on the right, including viewing
              progress and accessing important document actions.
            </Typography>
          </Box>
        )}

        {/* Completed Message */}
        {showCompletedMessage && (
          <Box
            sx={{
              mt: 4,
              px: 2,
              textAlign: "center",
              bgcolor: "#f0fdf4",
              border: "1px solid #10b981",
              borderRadius: "8px",
              py: 3,
            }}
          >
            <Typography
              variant="h6"
              color="primary"
              fontWeight="bold"
              gutterBottom
            >
              ✅ {recordDone ? "Recording" : "Notarization"} Completed
            </Typography>
            <Typography variant="body2" color="primary">
              Your document has been successfully{" "}
              {recordDone ? "recorded" : "notarized"}. You can now download the
              finalized PDF.
            </Typography>

            <Box mt={2}>
              <LoadingButton
                loading={ppDownloading}
                variant="contained"
                color="success"
                startIcon={<DownloadIcon />}
                href={
                  selectedRow?.recording_download_url ||
                  selectedRow?.notarization_download_url
                }
                target="_blank"
                onClick={() => setFileSizeModalOpen(true)}
              >
                Download Document
              </LoadingButton>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default React.memo(CustomDocumentMiddleContent);
